import { Search, X } from "lucide-react";

type FaqSearchControlProps = {
  query: string;
  onQueryChange: (query: string) => void;
  totalCount: number;
  resultCount: number;
  resultsId: string;
  label?: string;
};

export function FaqSearchControl({
  query,
  onQueryChange,
  totalCount,
  resultCount,
  resultsId,
  label = "Search frequently asked questions",
}: FaqSearchControlProps) {
  const hasQuery = query.trim().length > 0;
  const resultLabel = hasQuery
    ? `${resultCount} ${resultCount === 1 ? "answer" : "answers"} found from ${totalCount}`
    : `${totalCount} answers available`;

  return (
    <div className="mb-6 max-w-xl">
      <label htmlFor={resultsId} className="sr-only">
        {label}
      </label>
      <div className="relative">
        <Search aria-hidden="true" className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          id={resultsId}
          type="search"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search FAQs"
          aria-describedby={`${resultsId}-status`}
          aria-controls={`${resultsId}-results`}
          className="h-11 w-full rounded-md border border-border bg-background py-2 pl-10 pr-11 text-sm text-foreground shadow-sm outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-[#FF8C00] focus-visible:ring-2 focus-visible:ring-[#FF8C00]/40"
        />
        {hasQuery ? (
          <button
            type="button"
            onClick={() => onQueryChange("")}
            className="absolute right-1 top-1/2 inline-flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF8C00]"
            aria-label="Clear FAQ search"
          >
            <X aria-hidden="true" className="h-4 w-4" />
          </button>
        ) : null}
      </div>
      <p id={`${resultsId}-status`} className="mt-2 text-xs text-muted-foreground" aria-live="polite">
        {resultLabel}
      </p>
    </div>
  );
}
